module.exports = __webpack_public_path__ + "img/shade.75c2c79b.png";